<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/purchaseorder/list">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                <v-text-field
                  dense
                  :full-width=$vuetify.breakpoint.smAndDown
                  outlined
                  hide-details
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width:40%"><img :src="logo" height="50"  alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Order Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.purchaseordernum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.purchaseorderdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h4 class="ma-0">{{ initvalue.purchaseordertype }}</h4></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text" cols="12">
                  <v-col cols="12">
                  
                  </v-col>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr>
                      <td style="width: 35%; vertical-align: text-top">
                        <div>
                          <span style="font-size: 11pt; font-weight: bold">Vendor</span>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.purchaseordername }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.purchaseorderaddress }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ regions.find(region=>region._id == initvalue.regionid)['regionname'] }} </p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.purchaseorderphone }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.purchaseordermobile }}</p>
                        </div>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td style="width: 45%; text-align: right; vertical-align: text-top">
                        <table  style="width: 100%">
                          <tr v-if="!isTrade">
                            <td><span style="font-size: 11pt; font-weight: bold">Vendor Type</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.vendortype }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Rep</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  users.find(user=>user._id == initvalue.userid)['username']  }}</span></td>
                          </tr>
                          <tr v-if="isTrade">
                            <td><span style="font-size: 11pt; font-weight: bold">Incoterms</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  initvalue.trade.incoterms }}</span></td>
                          </tr>
                          <tr v-if="isTrade">
                            <td><span style="font-size: 11pt; font-weight: bold">Ref Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  initvalue.trade.refnum }}</span></td>
                          </tr>
                          <tr v-if="isTrade">
                            <td><span style="font-size: 11pt; font-weight: bold">Port of Loading</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  initvalue.trade.portloading }}</span></td>
                          </tr>
                          <tr v-if="isTrade">
                            <td><span style="font-size: 11pt; font-weight: bold">Port of Discharge</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  initvalue.trade.portdischarge }}</span></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div>&nbsp;&nbsp;</div>
                </v-row>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Item</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Foc</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Qty</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Unit</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Price</th>
                      <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid">Total</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transaction"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}</td>
                          <td>{{ trans.itemname }}</td>
                          <td>{{ trans.itemfoc }}</td>
                          <td>{{ trans.itemquantity }}</td>
                          <td>{{ trans.unit }}</td>
                          <td>{{ trans.itemprice }}</td>
                          <td style="text-align: right">{{ trans.itemamount }}</td>
                        </tr>
                        <tr><td colspan="7" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td colspan="3" rowspan="3" style="vertical-align: text-top; "><strong>Note:</strong>{{ initvalue.saleordernote }}</td>
                          <td colspan="3"><span style="font-size: 11pt; font-weight: bold">Subtotal: </span></td>
                          <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.purchaseordersubtotal }}</span></td>
                        </tr>
                        <tr>
                          <td colspan="3"><span style="font-size: 11pt; font-weight: bold">Delivery: </span></td>
                          <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.purchaseorderdeliveryfee }}</span></td>
                        </tr>
                        <tr>
                          <td colspan="3"><span style="font-size: 11pt; font-weight: bold">Total: </span></td>
                          <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.purchaseordertotal }}</span></td>
                        </tr>
                        <tr v-if="!isTrade">
                          <td colspan="3">
                          <td colspan="3" style="border-top: 1px; border-top-style: dotted"><span style="font-size: 11pt; font-weight: bold">Received: </span></td>
                          <td style="text-align: right; border-top: 1px; border-top-style: dotted"><span style="font-size: 11pt;">{{ initvalue.cashreceipt }}</span></td>
                        </tr>
                        <tr v-if="!isTrade">
                          <td colspan="3">
                          <td colspan="3"><span style="font-size: 11pt; font-weight: bold">Change: </span></td>
                          <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.cashchange }}</span></td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <table style="width: 50%" cellpadding="0" cellspacing="0">
                <tr><td style="text-align: right; border-bottom: 2px; border-bottom-style: solid"></td><td></td></tr>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
            isTrade: false,
          };
        },
        methods: {
          ...mapActions('User', ['getUsersRequest']),
          ...mapActions('Region', ['getRegionsRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          }
        },
        computed: {
          ...mapState('Region', ['regions']),
          ...mapState('User', ['users']),
        },
        created () {
          this.initvalue = this.$route.params;
          if(!this.initvalue._id) this.$router.push({ name: 'PurchaseOrderList' });
          if(this.regions.length==0){this.getRegionsRequest()}
          if(this.users.length==0){this.getUsersRequest()}
          if(this.initvalue.companyid=='60a8acb67418a3429476cd42'){
            this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhs-logo.png';
            this.isTrade = true;
          }
          else if(this.initvalue.companyid=='60b07f300d820029acae4734'){
            this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/alh-logo.png';
          }   
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
